import { render, staticRenderFns } from "./ProductMeasureGroups.vue?vue&type=template&id=77e92098&"
import script from "./ProductMeasureGroups.vue?vue&type=script&lang=ts&"
export * from "./ProductMeasureGroups.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports